import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import CruiseVerticalUSPs from 'components/Cruises/CruiseOfferPage/content/BookWithConfidence/CruiseVerticalUSPs'
import { useIntl } from 'react-intl'

function CruisePageUSPsSection() {
  const intl = useIntl()
  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group direction="vertical" gap={20}>
        <Heading variant="heading3" align="center">
          {intl.formatMessage({
            id: 'BO1ZPzfNouTWaFhekdTQ',
            defaultMessage: 'Why you should book with us',
            description: 'Section heading for why book with us section in the cruises section',
          })}
        </Heading>

        <CruiseVerticalUSPs />
      </Group>
    </LayoutContainer>
  </Group>
}

export default CruisePageUSPsSection
